import React from 'react'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import OfferPagePackageInclusionsList from '../OfferPagePackageInclusionsList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { EmptyArray } from 'lib/array/arrayUtils'
import { connect } from 'react-redux'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { isCustomerSupportMode } from 'selectors/featuresSelectors'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import { useIntl } from 'react-intl'

interface MappedProps {
  canViewLuxPlusBenefits: boolean
  isCustomerSupportMode: boolean
}
interface Props extends MappedProps {
  bonusInclusions: Array<App.PackageInclusion>
  inclusions: Array<App.PackageInclusion>
  luxPlusInclusions?: Array<App.PackageInclusion>
  flightInclusion?: App.OfferInclusion
  offer?: App.Offer
  stayPayRateTier?: App.StayPayTier
}

function RenderInclusions(props: Props) {
  const intl = useIntl()
  const {
    bonusInclusions,
    inclusions,
    luxPlusInclusions = EmptyArray,
    flightInclusion,
    offer,
    stayPayRateTier,
  } = props

  const allInclusions = inclusions.filter(inclusion => !inclusion.hasTactical)
  const hasInclusions = allInclusions.length > 0
  const hasBonusInclusions = bonusInclusions.length > 0
  const hasTacticalInclusions = bonusInclusions.filter(inclusion => inclusion.hasTactical).length > 0

  const hasLuxPlusInclusions = luxPlusInclusions.length > 0

  const hasAnyInclusions = hasInclusions || hasBonusInclusions || hasLuxPlusInclusions || flightInclusion || stayPayRateTier

  if (!hasAnyInclusions) return null

  return (
    <VerticalSpacer gap={12}>
      {hasLuxPlusInclusions && <LuxPlusInclusions
        luxPlusInclusions={luxPlusInclusions}
        accommodationOffer={offer}
      />}
      {/* TODO: eslint-disable-next-line formatjs/no-literal-string-in-jsx — behavioural discriminator, not display text */}
      {(hasBonusInclusions) && (
        <OfferPagePackageInclusionsList title="bonus">
          {bonusInclusions.map((bonusInclusion) => <OfferInclusionItem
            key={bonusInclusion.id}
            inclusion={bonusInclusion}
            isHighlighted={hasTacticalInclusions}
          />)}
        </OfferPagePackageInclusionsList>
      )}
      {stayPayRateTier && <BodyTextBlock variant="medium" startIcon={<LineCheckIcon />}>
        {intl.formatMessage(
          {
            id: 'UGG3aLDC1zM-bkWQyWZl',
            defaultMessage: '{count, plural, one {# night} other {# nights}} free',
            description: 'Promotional text showing number of free nights included in a stay/pay offer',
          },
          { count: stayPayRateTier.freeNights },
        )}
      </BodyTextBlock>}
      {/* TODO: eslint-disable-next-line formatjs/no-literal-string-in-jsx — behavioural discriminator, not display text */}
      {hasInclusions && (
        <OfferPagePackageInclusionsList title={hasBonusInclusions ? 'additional' : undefined}>
          {flightInclusion && <OfferInclusionItem inclusion={flightInclusion} isHighlighted />}
          {allInclusions.map(inclusion => <OfferInclusionItem
            key={inclusion.id}
            inclusion={inclusion}
          />)}
        </OfferPagePackageInclusionsList>
      )}
    </VerticalSpacer>
  )
}

const mapStateToProps = (state: App.State): MappedProps => ({
  canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
  isCustomerSupportMode: isCustomerSupportMode(state),
})

export default connect(mapStateToProps)(RenderInclusions)
